import Length from '../../../../source/js/shared/models/Geometry/Length';
import { MaximumDecimalPoints } from "@/Models/Validators/MaximumDecimalPoints";
import { MinimumValue } from "@/Models/Validators/MinimumValue";
import { MaximumValue } from "@/Models/Validators/MaximumValue";
import { ShapeConfigurationInterface } from './ShapeConfigurationInterface';
import { MinimumRatio } from '../Validators/MinimumRatio';
import { ShapeCategory } from '@/types/shapeCategories';

export default class ArchedRectangleConfiguration implements ShapeConfigurationInterface {
	get_dimension_keys(): string[] {
		return [
			'width',
			'height',
		];
	}

	get_modifier_keys(): string[] {
		return [];
	}

	get_maximum_dimensions( maximum_rectangle ): Record<string, Length> {
		return {
			width: maximum_rectangle.get_shortest_side(),
			height: maximum_rectangle.get_longest_side(),
		};
	}

	get_labels(): Record<string, string> {
		const { height, width } = window.measurementSelectorVariables.i18n.dimensionNames;

		return {
			width,
			height,
		};
	}

	get_validators(): Record<string, Array<unknown>> {
		return {
			width: [ MaximumDecimalPoints, MinimumValue, MaximumValue, MinimumRatio ],
			height: [ MaximumDecimalPoints, MinimumValue, MaximumValue, MinimumRatio ],
		};
	}

	get_category(): ShapeCategory {
		return 'circular';
	}
}
